/** Files to and from the compliance API: CSV exports to save, CSV imports to send (plan E05-T05). */
import type { Schemas } from "../api/client";

/** Saves `blob` as a file the browser downloads. */
export function save(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** Today, for a file name: consents-2026-10-01.csv. */
export function stamped(prefix: string, now = new Date()) {
  return `${prefix}-${now.toISOString().slice(0, 10)}.csv`;
}

/** What openapi-fetch needs to send a CSV body as it is. */
export const CSV = {
  bodySerializer: (body: string) => body,
  headers: { "Content-Type": "text/csv" },
} as const;

type Sources = Schemas["Profile"]["sources"];

/**
 * Where a rule comes from: its key's sources (`caller_id.number_series`), or, for a reason that
 * names a section (`calling_window`, `consent`, `dnc`), the sources of every key of that section.
 */
export function sourcesOf(rule: string, sources: Sources | undefined): string[] {
  if (!sources) return [];
  if (sources[rule]) return sources[rule] ?? [];
  const section = rule.split(".")[0] ?? rule;
  return Object.entries(sources)
    .filter(([key]) => key === section || key.startsWith(`${section}.`))
    .flatMap(([, list]) => list);
}
